import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import "./LanguageSelectionModal.css";

interface LanguageSelectionModalProps {
  show: boolean;
  handleClose: () => void;
}

const LanguageSelectionModal: React.FC<LanguageSelectionModalProps> = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="modal-body-center">
        <div className="languageAndClosebtn">
          <div>
            <p className="selectLanguageTxt">
              Select Language
            </p>
          </div>
          <div >
            <Button className="close-button" onClick={handleClose}>
              &times;
            </Button>
          </div>
        </div>
        <p>
          Choose any of the following options to start reading
        </p>
        <div className="language-options-container">
          <div>
            <Link to="/content/sanskrit">
              <span className="language-options">
                <p className='languageTypeTxt'>SANSKRIT</p>
              </span>
            </Link>
          </div>
          <div>
          <Link to="/content/english">
            <span className="language-options">
              <p className='languageTypeTxt'>ENGLISH</p>
            </span>
            </Link>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LanguageSelectionModal;
